/**
 * Bloqueio das imagens da loja (stickers, cartas, placas, pacotes, molduras):
 * sem botao direito, sem arrastar, sem "segurar para salvar" e sem o menu
 * "Inspecionar imagem". Instala sozinho ao ser importado.
 */
const IMG = 'img[src*="/stickers/"]';
const AREA =
  ".ct,.fc,.pa,.tm-art,.tm-prev,.gf-it,.iv-t,.pc-fr,.sm-big,.sm-mini,.sm-it,.pk-item,.pk-thb,.dk,.sm-ov,.po-ov,[data-guard]";

let installed = false;

export function installImageGuard() {
  if (installed || typeof document === "undefined") return;
  installed = true;

  const st = document.createElement("style");
  st.textContent = `
${IMG}{-webkit-user-drag:none;-webkit-touch-callout:none}
:is(.ct,.fc,.pa,.tm-art,.tm-prev,.gf-it,.gf-g,.iv-t,.iv-oi,.pc-fr,.sm-big,.sm-mini,.sm-it,.pk-item,.pk-thb,.dk,.cc-wrap) img{pointer-events:none;-webkit-user-drag:none;-webkit-touch-callout:none}
:is(.ct,.fc,.pa,.tm-art,.tm-prev,.gf-it,.iv-t,.pc-fr,.sm-big,.sm-mini,.sm-it,.pk-item,.pk-thb,[data-guard]){-webkit-touch-callout:none;-webkit-user-select:none;user-select:none}
`;
  document.head.appendChild(st);

  const hit = (t: EventTarget | null) => {
    const el = t as Element | null;
    return !!el?.closest?.(`${IMG},${AREA}`);
  };
  document.addEventListener(
    "contextmenu",
    (e) => {
      if (hit(e.target)) e.preventDefault();
    },
    true,
  );
  document.addEventListener(
    "dragstart",
    (e) => {
      if (hit(e.target)) e.preventDefault();
    },
    true,
  );
}

installImageGuard();
